import {
  Component,
  Input,
  OnInit,
  DoCheck,
  IterableDiffers,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { WfTableComponent } from './wf-table.component';
import { PaginationEngine } from '../../Models/enum/paginationEngine';

@Component({
  selector: 'app-table-sort',
  templateUrl: './table-sort.component.html',
  styleUrls: ['./table-sort.component.css']
})
export class TableSortComponent implements OnInit, DoCheck, OnChanges {

  @Input() columnName: string;
  @Input() dataTable: WfTableComponent;
  @Output() sortData: EventEmitter<any> = new EventEmitter();

  @Input() sortDirection: SortDirection = SortDirection.none;
  @Input() paginationEngine: PaginationEngine = PaginationEngine.client;
  @Input() firstSortColumnName?: string;

  sortGenericClass = 'fa-sort';
  sortAscClass = 'fa-sort-up';
  sortDescClass = 'fa-sort-down';
  differ: any;


  constructor(differs: IterableDiffers) {
    this.differ = differs.find([]).create(null);
  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes['dataTable'].currentValue && this.firstSortColumnName && this.sortDirection) {
      this.sortDirection === 1 ? this.sortDirection = 2 : this.sortDirection = 1;
      this.changeIcon();
      this.firstSortColumnName = null;
    }
  }

  ngDoCheck() {
    if (!this.dataTable || !this.dataTable.rows) {
      return;
    }
    const change = this.differ.diff(this.dataTable.rows);
    if (change) {
      let span = this.getSpanElement();
      if (change && this.dataTable.lastColumnSort && this.dataTable.lastColumnSort != this.columnName && span && this.sortDirection != SortDirection.none){
        this.sortDirection = SortDirection.none;
        span.classList.remove(this.sortDescClass);
        span.classList.remove(this.sortAscClass);
        span.classList.add(this.sortGenericClass);
      }
    }
  }

  getSpanElement() {
    if (this.dataTable) {
      const elementId = this.firstSortColumnName ? `sort_${this.firstSortColumnName}_${this.dataTable.dataTableId}` : this.getSortId();
      const span = document.getElementById(elementId);
      return span;
    }
  }

  onSort() {
    if (!this.dataTable || !this.dataTable.rows || !this.columnName) {
      return;
    }

    this.changeIcon();

    if (this.paginationEngine === 1) {
      const filterInfo = {
        columnName: this.columnName,
        sortDirection: this.sortDirection
      };
      this.sortData.emit(filterInfo);
    } else {
      this.sortRows();
    }

    this.dataTable.lastColumnSort = this.columnName;
  }

  changeIcon() {
    const span = this.getSpanElement();
    if (span) {
      switch (this.sortDirection) {
        case SortDirection.none:
        case SortDirection.desc:
          this.sortDirection = SortDirection.asc;
          span.classList.remove(this.sortGenericClass);
          span.classList.remove(this.sortDescClass);
          span.classList.add(this.sortAscClass);
          break;
        case SortDirection.asc:
          this.sortDirection = SortDirection.desc;
          span.classList.remove(this.sortAscClass);
          span.classList.add(this.sortDescClass);
          break;
      }
    }
  }

  sortRows() {
    if (this.sortDirection == SortDirection.asc) {
      this.dataTable.rows.sort((one, two) => {
        if (typeof(two[this.columnName]) === 'boolean' && typeof(one[this.columnName]) === 'boolean') {
          return one[this.columnName].toString().localeCompare(two[this.columnName].toString());
        } else if (typeof(one[this.columnName]) === 'number' && typeof(two[this.columnName]) === 'number') {
          return one[this.columnName] - two[this.columnName] ;
        } else {
          if (!one[this.columnName]) { return -1; }
          if (!two[this.columnName]) { return 1; } else { return one[this.columnName].localeCompare(two[this.columnName]); }
        }
      });
    } else {
      this.dataTable.rows.sort((one, two) => {
        if (typeof(two[this.columnName]) === 'boolean' && typeof(one[this.columnName]) === 'boolean') {
          return two[this.columnName].toString().localeCompare(one[this.columnName].toString());
        } else if (typeof(two[this.columnName]) === 'number' && typeof(one[this.columnName]) === 'number') {
          return two[this.columnName] - one[this.columnName];
        } else {
          if (!two[this.columnName])  { return -1; }
          if (!one[this.columnName]) { return 1; } else { return two[this.columnName].localeCompare(one[this.columnName]); }
        }
      });
    }
  }

  getSortId() {
      return 'sort_' + this.columnName + '_' + this.dataTable.dataTableId;
  }


}
export enum SortDirection {
  none,
  asc,
  desc
}
